import { render, staticRenderFns } from "./PedidoView.vue?vue&type=template&id=3512c715&"
import script from "./PedidoView.vue?vue&type=script&lang=js&"
export * from "./PedidoView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports